import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const storedUser = window.localStorage.getItem('mg_user')

export default new Vuex.Store({
  state: {
    token: window.localStorage.getItem('mg_token') || '',
    user: storedUser ? JSON.parse(storedUser) : null
  },
  mutations: {
    setSession (state, payload) {
      state.token = payload.token
      state.user = payload.user
      window.localStorage.setItem('mg_token', payload.token)
      window.localStorage.setItem('mg_user', JSON.stringify(payload.user))
    },
    clearSession (state) {
      state.token = ''
      state.user = null
      window.localStorage.removeItem('mg_token')
      window.localStorage.removeItem('mg_user')
    }
  }
})

